import { defineMessages } from 'react-intl'

export default defineMessages({
  markJuniorTalent: {
    id: 'containers.AdminSupplierOnboarding.components.Supplier.components.MarkJuniorTalentMenuItem.markJuniorTalent',
    defaultMessage: 'Mark as Junior Talent',
  },
  success: {
    id: 'containers.AdminSupplierOnboarding.components.Supplier.components.MarkJuniorTalentMenuItem.success',
    defaultMessage: 'Supplier marked as Junior talent',
  }
})
